import ConcertBG from "../../assets/images/ConcertBg.png"

const TopBanner = () => {
    return (
        <div className="fixed cursor-pointer top-0 left-0 w-full h-[50px] flex justify-center items-center z-50"
            style={{ backgroundImage: `url(${ConcertBG}) `}}
            onClick={() => window.open("https://muzify.com")}
        >
            <p className="md:text-[28px] text-[20px] text-center text-[rgba(255,255,255,1)]">
              We are now Muzify!
            </p>
        </div>
    )
}

export default TopBanner
